export enum TournamentTypes {
  Ongoing = 1, // 进行中
  Upcoming = 2, // 即将开始
  Ended = 3, // 已结束
}

export type TournamentItemTypes = {
  begin_at: number;
  deny_pack: number[];
  deny_pack_type: number;
  deny_labels: number[];
  deny_label_type: number;
  enable: number; // 是否开启，1=开启，2=关闭
  end_at: number;
  game_ids: number[];
  games: {
    game_id: number; // 游戏ID
    game_name: string; // 游戏名称
    class: number; // 游戏分类
  }[];
  map_lang_to_desc: Record<
    string,
    {
      game_mode: string;
      h5_addr: string;
      pic_addr: string;
      name: string;
      rule_desc: string;
      reward_amount: number; // 不管
    }
  >; // 多语言描述
  match_status: number; // 比赛状态，0=全部，1=进行中，2=即将开始，3=已结束
  sort: number; // 排序
  total_reward: number; // 总奖金
  type: number; // 1=厂商活动
  user_name: string; // 用户名称
  is_expired: number; // 是否过期，0=否，1=是
};

export type TournamentConfigTypes = {
  active_img: Record<number, string>;
  active_text_type: number;
  atype: number;
  bonus_category: number;
  cfg: {
    races: TournamentItemTypes[];
  };
  deny_label_type: number;
  deny_labels: number[];
  deny_pack: number[];
  deny_pack_type: number;
  etime: number;
  rules: Record<string, string>;
  sort: number;
  status: boolean;
  stime: number;
};
